// hooks/useGpsEntregador.js
import { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';

const SOCKET_URL = 'https://app.universomidiadigital.com.br';

export const useGpsEntregador = (pedidoId = null) => {
    const [posicaoMoto, setPosicaoMoto] = useState(null);
    const socket = useRef(null);

    useEffect(() => {
        if (!pedidoId) return;

        socket.current = io(SOCKET_URL);
        
        // Entra na sala do pedido para receber as atualizações
        socket.current.emit('join-pedido', pedidoId);

        // Ouve a posição vinda do servidor
        socket.current.on('moto-position', (data) => {
            if (data.lat && data.lng) {
                setPosicaoMoto([parseFloat(data.lat), parseFloat(data.lng)]);
            }
        });

        return () => socket.current?.disconnect();
    }, [pedidoId]);

    return { posicaoMoto, socket: socket.current };
};